import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import ChangePass from '@/views/account/ChangePass'
import Register from '@/views/Register'
import Login from '@/views/Login'
import ResetPassword from '@/views/ResetPassword'
import UpdatePassword from '@/views/UpdatePassword'
import Profile from '../views/account/Profile.vue'

// Pengajuan
import AddHeader from '@/views/Pengajuan/AddHeader'
import DetilHeader from '@/views/Pengajuan/DetilHeader'
import ListPengajuan from '@/views/Pengajuan/Pengajuan' // ganti versi
import Upload from '@/views/Pengajuan/Upload'

// Brows
import ListBrows from '@/views/Brows/ListBrowsV2'
import DetilBrows from '@/views/Brows/DetilBrows'
import BrowseUpload from '@/views/Brows/browseupload'

import BrowseFTZ from '@/views/Brows/browseftz'
import PengajuanFTZ from '@/views/Pengajuan/PengajuanFtz'
import AddHeaderFTZ from '@/views/Pengajuan/AddHeaderFtz'
import DetilHeaderFTZ from '@/views/Pengajuan/DetilHeaderFtz'
import DetilBrowsFTZ from '@/views/Brows/DetilBrowsFtz'

// SPPBMCP
import ListSPPBMCP from '@/views/SPPBMCP/listsppbmcp'

// Rekon Manifes
import addBL from '@/views/RekonManifes/addbl'
import browseBL from '@/views/RekonManifes/browsebl'

// Page 404
import Page404 from '@/views/page404'

// Ppftz
import BarPin from '@/views/ppftz/MenuAju'
import RekamBarPin from '@/views/ppftz/Perekaman'
import BrowseBarPin from '@/views/ppftz/Browse'
import DetilBrowseBarpin from '@/views/ppftz/browse/DetilPpftz'

// Transit
import FormTransit from '@/views/transit/FormTransitNew'
import FormTransitA from '@/views/transit/FormTransitA'
import ResultTransit from '@/views/transit/ResultTransit'
import MenuTransit from '@/views/transit/MenuTransit'

// WBBM
import Pengumuman from '@/views/pengumuman'

// GOOGLE AUTH
import Tfasetup from '@/views/Tfasetup'
import Tfaverify from '@/views/Tfaverify'

Vue.use(Router)
// JENIS AKUN
// M = PPFTZ MANUAL
// N = IMPORTIR/EKSPORTIR
// Y = PPJK
// S = TPS

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      // will match everything
      path: '*',
      component: Page404
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y', 'M']
          }
        },
        {
          path: 'changepass',
          name: 'Change Password',
          component: ChangePass,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y', 'M']
          }
        }
      ]
    },
    {
      path: '/pengajuan',
      redirect: '/pengajuan/listpengajuan',
      name: 'Pengajuan',
      component: Full,
      children: [
        {
          path: 'listpengajuan',
          name: 'List',
          component: ListPengajuan,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'header',
          name: 'Header',
          component: AddHeader,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'detilheader/:idmohon',
          name: 'DetilHeader',
          component: DetilHeader,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'dokap',
          name: 'Dokumen Pelengkap',
          component: AddHeader,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: '/pengajuan/upload',
          name: 'Upload Laporan',
          component: Upload,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }
      ]
    },
    {
      path: '/brows',
      redirect: '/brows/listbrows',
      name: 'Browse',
      component: Full,
      children: [
        {
          path: 'listbrows',
          name: 'List Browse',
          component: ListBrows,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'detilbrows/:idmohon',
          name: 'Detil Browse',
          component: DetilBrows,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: '/pengajuan/browseupload',
          name: ' Browse Upload Laporan',
          component: BrowseUpload,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }
      ]
    },
    {
      path: '/browseftz',
      redirect: '/browseftz/list',
      name: 'Browse PPFTZ',
      component: Full,
      children: [
        {
          path: 'list',
          name: 'List Browse',
          component: BrowseFTZ,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'list/:idmohon',
          name: 'Detil Browse',
          component: DetilBrowsFTZ,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }
      ]
    },
    {
      path: '/pengajuanftz',
      redirect: '/pengajuanftz/list',
      name: 'Pengajuan',
      component: Full,
      children: [
        {
          path: 'list',
          name: 'List Pengajuan FTZ',
          component: PengajuanFTZ,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'addheader',
          name: 'Tambah Pengajuan FTZ',
          component: AddHeaderFTZ,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: 'detilheader/:idmohon',
          name: 'DetilHeader Gabungan',
          component: DetilHeaderFTZ,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }
      ]
    },
    {
      path: '/sppbmcp',
      redirect: '/sppbmcp/listsppbmcp',
      name: 'SPPBMCP',
      component: Full,
      children: [
        {
          path: 'listsppbmcp',
          name: 'List SPPBMCP',
          component: ListSPPBMCP,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }
      ]
    },
    {
      path: '/rekonmanifes/',
      redirect: '/rekonmanifes/browse',
      name: 'Browse',
      component: Full,
      children: [
        {
          path: '/rekonmanifes/browse',
          name: 'Browse BL/AWB',
          component: browseBL,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        },
        {
          path: '/rekonmanifes/add',
          name: 'Tambah BL/AWB',
          component: addBL,
          meta: {
            forAuth: true,
            access: ['N', 'S', 'Y']
          }
        }]
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/resetpassword',
      name: 'Lupa Password',
      component: ResetPassword,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/updatepassword/:token',
      name: 'Lupa Password',
      component: UpdatePassword,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/ppftz/',
      redirect: '/ppftz/browse',
      name: 'PPFTZ Manual',
      component: Full,
      children: [
        {
          path: '/ppftz/perekaman',
          name: 'Perekaman',
          component: BarPin,
          meta: {
            forAuth: true,
            access: ['M', 'Y']
          }
        },
        {
          path: '/ppftz/perekaman/:id',
          name: 'Perekaman',
          component: RekamBarPin,
          meta: {
            forAuth: true,
            access: ['M', 'Y']
          }
        },
        {
          path: '/ppftz/browse',
          name: 'Browse',
          component: BrowseBarPin,
          meta: {
            forAuth: true,
            access: ['M', 'Y']
          }
        },
        {
          path: '/ppftz/browse/:id',
          name: 'Browse',
          component: DetilBrowseBarpin,
          meta: {
            forAuth: true,
            access: ['M', 'Y']
          }
        }
      ]
    },
    {
      path: '/menutransit',
      name: 'Pemberitahuan Barang Transit',
      component: MenuTransit,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/formtransit',
      name: 'Pemberitahuan Barang Transit',
      component: FormTransit,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/formtransitA-aquarayaikn',
      name: 'Pemberitahuan Barang Transit',
      component: FormTransitA,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/resulttransit/:id',
      name: 'Kode Registrasi',
      component: ResultTransit,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/pengumuman',
      name: 'Pengumuman WBBM',
      component: Pengumuman,
      meta: {
        forVisitors: true
      }
    },
    {
      path: '/tfa/setup',
      name: 'TFA Setup',
      component: Tfasetup
    },
    {
      path: '/tfa/verify',
      name: 'TFA Verify',
      component: Tfaverify
    }
  ]
}
)



// WEBPACK FOOTER //
// ./src/router/index.js